import React, { useEffect, useContext } from 'react';
import { useStaticQuery, graphql } from "gatsby";

import { SectionAppearanceContext } from '../SectionContext';

import { checkAppearanceInViewport } from '../../../utils/checkAppearanceInViewport';

import {
    SHeroContainer,
    SHeroContent,
    SHeroHeader,
    SHeroSubheader,
    SHeroText,
} from './styles';

import Section from '../../layout/Section';
import HeroGraphic from './HeroGraphic';

const SectionHeroStart = ({ config }) => {
    const {
        title,
        id,
        subtitle,
        content,
        forwardedRef,
    } = config;

    const [ activeSection, setActiveSection ] = useContext(SectionAppearanceContext);

    const handleSetCurrentSection = sectionId => {
        if (sectionId !== activeSection) {
            setActiveSection(sectionId);
        }
    };

    useEffect(() => {
        checkAppearanceInViewport(
            forwardedRef,
            handleSetCurrentSection
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forwardedRef]);

    const heroImage = useStaticQuery(
        graphql`
            {
                file(relativePath: { eq: "start_hero2_graphic.png" }) {
                    childImageSharp {
                        gatsbyImageData(layout: FULL_WIDTH)
                    }
                }
            }
        `
    );

    return (
        <Section
            id={ id }
            forwardedRef={ forwardedRef }
        >
            <SHeroContainer>
                <SHeroContent>
                    <SHeroHeader>
                        { title }
                    </SHeroHeader>
                    <SHeroSubheader>
                        { subtitle }
                    </SHeroSubheader>
                    {
                        content.map(({ text }) => (
                            <SHeroText key={ text }>
                                { text }
                            </SHeroText>
                        ))
                    }
                </SHeroContent>
                <HeroGraphic
                    imageData={ heroImage }
                />
            </SHeroContainer>
        </Section>
    );
};

export default SectionHeroStart;
